<template>
    <div style="position: relative;">
        <div v-if="showIntervalArrows && showLeftArrow" @click="getDataInInterval(true)" class="chart-left-arrow"><b-icon-caret-left></b-icon-caret-left><span>{{$t('lessRecent')}}</span></div>
        <highcharts :options="chartOptions"></highcharts>
        <div v-if="showIntervalArrows && showRightArrow" @click="getDataInInterval(false)" class="chart-right-arrow">{{$t('moreRecentHabit')}}<b-icon-caret-right></b-icon-caret-right><span></span></div>
    </div>
</template>

<script>
import '@/plugins/highchartsLanguageConfig'

export default {
   name: 'healthyHabitsChart',
   components: {
   },
   computed: {
   },
   props: {
    chartOptions: Object,
    showIntervalArrows: Boolean
   },
   created () {
    if (this.chartOptions.id) {
        this.id = this.chartOptions.id.split('-')[0]
        this.processScoreData()
        this.showLeftArrow = this.dataPerPage.length > 1
    }
   },
   data () {
    return {
        id: null,
        showLeftArrow: true,
        showRightArrow: false,
        dataPerPage: [],
        page: 0,
        itemsPerPage: window.screen.width < 1000 ? 15 : 50
    }
   },
   methods: {
    processScoreData () {
        let data = this.$store.state.healthyHabits.chart[this.id].options.series[0].data
        let result = []
        let auxData = []
        let count = 1
        for (let index = data.length - 1; index >= 0; index--) {
            let item = data[index]
            auxData.unshift(item)
            if (count === this.itemsPerPage || index === 0) {
                result.push(auxData)
                count = 0
                auxData = []
            }
            count++
        }
        this.dataPerPage = result
        this.$store.state.healthyHabits.chart[this.id].options.series[0].data = this.dataPerPage[this.page]
    },
    getDataInInterval (previous) {
        if (previous) {
            this.page++
            this.$store.state.healthyHabits.chart[this.id].options.series[0].data = this.dataPerPage[this.page]
            this.showLeftArrow = this.dataPerPage.length - 1 > this.page
            this.showRightArrow = true
        } else {
            this.page--
            this.$store.state.healthyHabits.chart[this.id].options.series[0].data = this.dataPerPage[this.page]
            this.showLeftArrow = true
            this.showRightArrow = this.page > 0
        }
    }
   }
}
</script>

<style lang="scss">
.chart-left-arrow{
    position: absolute;
    left: 45px;
    bottom: 11%;
    font-size: 11px;
    z-index: 5;
    cursor: pointer;
    .b-icon.bi{
        vertical-align: -.20em;
    }
}
.chart-right-arrow{
    position: absolute;
    bottom: 11%;
    font-size: 11px;
    z-index: 5;
    cursor: pointer;
    right: 7px;
    .b-icon.bi{
        vertical-align: -.20em;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsChart.vue